var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMutedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73815 6.49967C3.73815 6.13526 4.03356 5.83984 4.39798 5.83984H7.60208C7.96649 5.83984 8.26191 6.13526 8.26191 6.49967V11.1712H6.94226V7.15949H5.0578V11.1712H3.73815V6.49967Z",
    fill: "#767D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59491 0.63899C5.83318 0.45367 6.16682 0.45367 6.40509 0.638991L11.2113 4.37711C11.372 4.50212 11.466 4.69433 11.466 4.89795V10.7721C11.466 11.2304 11.2839 11.6699 10.9599 11.9939C10.6359 12.318 10.1964 12.5 9.73812 12.5L2.25903 12.5C1.80151 12.4992 1.36297 12.3171 1.03959 11.9934C0.716213 11.6698 0.534396 11.2311 0.53402 10.7736L0.534019 4.89795C0.534019 4.69433 0.628026 4.50212 0.788751 4.37711L5.59491 0.63899ZM1.85367 5.22066V10.7727C1.85381 10.8807 1.89676 10.9843 1.97311 11.0607C2.04942 11.137 2.15287 11.1801 2.26081 11.1804C2.26068 11.1804 2.26094 11.1804 2.26081 11.1804H9.73812C9.84639 11.1804 9.95022 11.1373 10.0268 11.0608C10.1033 10.9842 10.1463 10.8804 10.1463 10.7721V5.22066L6 1.99573L1.85367 5.22066Z",
    fill: "#767D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMutedGrey);
export default __webpack_public_path__ + "static/media/home-muted-grey.4778bcc8b88927c26a2e96a1465dcc2b.svg";
export { ForwardRef as ReactComponent };